import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Head from 'next/head';
export function NextAppHead({ title, children }) {
    return (_jsxs(Head, { children: [_jsx("meta", { charSet: "UTF-8" }), _jsx("meta", { name: "viewport", content: `minimum-scale=1, initial-scale=1, width=device-width${typeof navigator !== 'undefined' &&
                    navigator.userAgent.indexOf('iPhone') > -1
                    ? ', maximum-scale=1'
                    : ''}` }), _jsx("title", { children: title }), children] }));
}
